import React from 'react'
import GaragePerfect from '../modules/GaragePerfect'
import GarageMultiFinish from '../modules/GarageMultiFinish'

const GridRomance = (props) => {
  return (
    <>
      {/* Grid 1 */}
      <GaragePerfect />
      {/* Grid 2 */}
      <GarageMultiFinish />
    </>
  )
}

export default GridRomance